<template>
  <div class="page page-films">
    <div class="container">
      <search-bar></search-bar>
      
      <div class="films-title">搜索結果</div>

      <div class="films-list clearfix" v-if="films.length">
        <router-link class="film-item" v-for="(v, i) in films" :key="v.id"
          :to="{ name: 'Film', params: { id: v.id } }" target="_blank"
          :style="{ animationDelay: `${i % 10 * 140}ms` }"
        >
          <div class="film-header" :style="$bgImg(v.cover)"></div>
          <div class="film-content">
            <div class="en-ttile">{{v.film_english_title}}</div>
            <div class="cn-title">{{v.film_title}}</div>
            <div class="desc">{{v.film_description || v.film_detail}}</div>
          </div>
        </router-link>
      </div>

      <div class="loading" v-if="loading">
        <i class="el-icon-loading"></i>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api'
import helpers from '../utils/helpers'
import SearchBar from '../components/SearchBar'

export default {
  components: { SearchBar },
  data() {
    return {
      films: [],
      loading: true,
      hasMore: true,
      page: 1,
      keyword: ''
    }
  },  
  watch: {
    $route(nv) {
      this.keyword = nv.query.keyword
      this.films = []
      this.getFilms(1)
    }
  },
  methods: {
    getFilms(page = this.page) {
      this.loading = true
      api.getFilms({ keyword: this.keyword, page }).then(data => {
        this.films = page == 1 ? data : this.films.concat(data)
        this.page = page
        this.loading = false
        this.hasMore = data.length > 9
      })
    },
    loadMore() {
      if (!this.loading && this.hasMore) {
        const top = document.documentElement.scrollTop || document.body.scrollTop
        const height = document.body.scrollHeight - document.body.clientHeight
        if (height - top < 350) {
          this.getFilms(this.page + 1)
        }
      }
    }
  },
  created() {
    this.keyword = this.$route.query.keyword
    this.getFilms()

    window.addEventListener('scroll', this.loadMore)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.loadMore)
  }
}
</script>

<style lang="less" scoped>
.page-films {
  background-color: #e8e8e8;
  padding-top: 30px;
  padding-bottom: 80px;
}

</style>
